import { h } from 'preact';
import { isLauraCanada } from 'utils/helpers';

const ProductStyleNumber = ({
  styleNumber,
  ...props
}) => {

  let currentStyleNumber = styleNumber;
   if (isLauraCanada()) {
      // Modify the style number format if the condition is met
      currentStyleNumber = `#${styleNumber}`;
    }

  return (
    <div {...props}>
        {currentStyleNumber}
    </div>
  );
};

export default ProductStyleNumber;
